import { useEffect, useState } from "react";

export default function CursorGlow() {
  const [pos, setPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setPos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div
      className="pointer-events-none fixed w-[200px] h-[200px] bg-[#6330A0]  blur-[160px] transition-transform duration-100"
      style={{
        left: pos.x - 80,
        top: pos.y - 80,
      }}
    />
  );
}
